import Orgs from "./orgs";
import Sites from "./sites";
import Users from "./users"

const DataService = {
  Orgs: new Orgs(),
  Sites: new Sites(),
  Users: new Users(),
} 

export default DataService;